<template>
  <div>
    <b-tabs lazy>
      <b-tab title="Stats:" disabled></b-tab>
      <b-tab title="Kpi" title-link-class="text-info">
        <ulu-agents-range-table />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  components: {
    "ulu-agents-range-table": () =>
      import("@/components/dashboard/agents/AgentsRangeTable")
  }
};
</script>
